import React, { useState } from 'react'
import LinkButton from '../../components/LinkButton'
import getVectorImage from '../../utils/getVectorImage'
import styles from './SideTable.module.scss'
import toTitleCase from '../../utils/toTitleCase'
import { useGeoState } from '../../components/GeoProvider'
import { useNavigate } from 'react-router-dom'
const Databind = ({ state, chartRef }) => {
  const { regionSelected } = useGeoState()
  const history = useNavigate()
  const [getPoint, setPoint] = useState()
  const handleMouseOver = (element) => {
    const chart = chartRef.current.chart
    var indexSeries =
      regionSelected === 'state' ? 0 : 3
    if (chart !== undefined && chart !== null) {
      const point = chart.series[indexSeries].points.find(
        (point) => point.geo_id === element.attributes['geo_id'].textContent
      )
      if (point !== undefined || point !== null) {
        setPoint(element.attributes['geo_id'].textContent)
        point.update({ borderWidth: 3 })
        chart.tooltip.refresh(point)
      }
    }
  }
  let istrue = state.rate_change_pct > 0 ? false: true
  let trend = state.rate_change_pct > 0 ? 'bttrendingup' : 'bttrendingdown'

  const handleMouseOut = () => {
    const chart = chartRef.current.chart
    if (chart && chart.tooltip) {
      chart.tooltip.destroy()
    }
    if (getPoint !== undefined) {
      var indexSeries =
        regionSelected === 'state' ? 0 : 3
      if (chart !== undefined && chart !== null) {
        const point = chart.series[indexSeries].points.find(
          (point) => point.geo_id === getPoint
        )
        if (point !== undefined || point !== null) {
          point.update({ borderWidth: 1 })
        }
      }
    }
  }
  const handleClick = () => {
    regionSelected.toUpperCase() === 'FIPS'
      ? history(
          `/birthtrendcountydashboard/${state.geo_parent}/county/${state.geo_id}`
        )
      : history(`/birthtrendstatedashboard/STATE/${state.geo_id}`)
  }
  if(state.geo_id.toUpperCase()!=='DC')
  {
  let statename =
    regionSelected.toUpperCase() === 'STATE'
      ? state.identifier + ' (' + state.geo_id + ')'
      : state.identifier + ' (' + state.geo_parent + ')'
  
  return (
    <div style={{ display: 'flex' }} className={styles.Layout}>
      <div
        style={{
          width: '75%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        title={state.identifier}
      >
        <LinkButton
          onMouseOver={(e) => handleMouseOver(e.target)}
          onMouseOut={() => handleMouseOut()}
          className={styles.btn}
          onClick={handleClick}
          data-title={statename}
          title={statename}
          geo_id={state.geo_id}
        >
          {statename}
        </LinkButton>
      </div>
      <div className={styles.columnRate}>{state.rate_per_100k}</div>
      <div className={styles.columnDays}>
        <span> {getVectorImage(trend,'20px','20px')} </span>
        <span
          className={istrue ? styles.percentageRed : styles.percentageGreen}
        >
          {' '}
          {Math.abs(state.rate_change_pct)}%
        </span>
      </div>
    </div>
  )
}
}

const SideTable = ({ stateData, chartRef }) => {
  const { regionSelected } = useGeoState()
  const stateDataForDisplayDate = Object.entries(stateData)
  const mappedStateData = stateDataForDisplayDate.map((state) => {
    const stateName = state[1].geo_name
    return { ...state[1], name: stateName, identifier: stateName }
  })
  let filteredStateData = mappedStateData
  const [getFilter, setfilter] = useState('down')
  const [getStateFilter, setStatefilter] = useState('down')
  const sortBy = (action) => {
    if (action === 'up') {
      setfilter('down')
      stateData.sort((a, b) => b.rate_per_100k - a.rate_per_100k)
    } else if (action === 'down') {
      setfilter('up')
      stateData.sort((a, b) => a.rate_per_100k - b.rate_per_100k)
    }
  }
  const sortStateBy = (action) => {
    if (action === 'up') {
      setStatefilter('down')
      stateData.sort((a, b) => (a.geo_name > b.geo_name ? 1 : -1))
    } else if (action === 'down') {
      setStatefilter('up')
      stateData.sort((a, b) => (a.geo_name > b.geo_name ? -1 : 1))
    }
  }
  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <div
          style={{
            width: '100%',
            justifyContent: 'flex-start',
            marginTop: '16px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'inline-flex',
                width: '99%',
              }}
            >
              <span>
                <h5
                  style={{
                    fontFamily: 'Optum Sans',
                    fontSize: '21px',
                    fontWeight: '600',
                    color: '#002677',
                  }}
                >
                 {regionSelected.toUpperCase()==='FIPS'?'Counties Birth Rate':toTitleCase(regionSelected) + ' Birth Rate'}
                  
                </h5>
              </span>
            </div>
           
          </div>
          <div
            style={{
              fontSize: '12px',
              display: 'flex',
              lineHeight: '18px',
              padding: '1rem 0rem 0',
            }}
          >
            <span> {getVectorImage('Info', '16px', '16px')}</span> &nbsp;&nbsp;
            <div
              style={{ '&::WebkitScrollbar': { width: 0, height: 0 } }}
              className={styles.sideTableHeader}
            >
              {' '}
              Estimated Monthly Data. Rate is per 100,000.
            </div>
          </div>
        </div>
        <div
          style={{
            padding: '0rem 0rem',
            paddingBottom: '0.5rem',
            paddingTop: '0.5rem',
            borderTop: '1px solid #CBCCCD',
            borderBottom: '2px solid #002677',
            marginTop: '5px',
          }}
        >
          <div style={{ display: 'inline-flex', width: '54%' }}>
            <h4 >
              {regionSelected === 'fips'
                ? 'Counties'
                : toTitleCase(regionSelected)+'s '}
              {'  '}
              <span onClick={() => sortStateBy(getStateFilter)} style={{ marginLeft: '4px',cursor: 'pointer' }}>
                {getVectorImage(getStateFilter)}
              </span>
            </h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '20%',
              justifyContent: 'flex-middle',
            }}
          >
            <h4 >
              Rate{' '}
              <span onClick={() => sortBy(getFilter)} style={{ marginLeft: '4px', cursor: 'pointer' }}>
                {getVectorImage(getFilter)}
              </span>
            </h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '26%',
              justifyContent: 'flex-middle',
            }}
          >
            <h4>Change</h4>
          </div>
        </div>
      </div>

      <div className={styles.scroll}>
        {filteredStateData.map((state) => {
          return (
            <Databind state={state} key={state.statename} chartRef={chartRef} />
          )
        })}
      </div>
    </div>
  )
}

export default SideTable
